import styled from 'styled-components';
import { animated } from 'react-spring';

const DotPlanet = styled(animated.div)`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.splashPlanet};
  position: absolute;
  transform: translate(-50%, -50%);
  top: 0;
  left: 50%;
`;

export default DotPlanet;
